export { getAnonCategories } from './getAnonFooterLinks';
export { default as getAuthFooterLinks } from './getAuthFooterLinks';
